exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.amplify-image[data-v-bd7c1ee0]{width:30%;margin:.2em;border-radius:6px;border:2px solid var(--color-white);cursor:pointer\n}", ""]);

// exports
